import { hillo } from 'hillo'

export async function getConfigIni () {
  return (await hillo.get('Restaurant.php?op=getConfigIni', {})).content
}

export async function updateConfigIni (config) {
  return (await hillo.post('Restaurant.php?op=updateConfigIni', {
    configData: JSON.stringify(config)
  }))
}
